import React from 'react';
import { useEntryDirectoryEvents } from '../../../context/EntryDirectoryContext';
import { strings } from '../../../localization';
import { useViewPicker } from '../context/ViewPickerContext';
import { ViewItemWizard } from './ViewItemWizard';

export const ManageViews = () => {
    const { manageDynamicLists, manageSavedLists } = useEntryDirectoryEvents();
    const { closePicker } = useViewPicker();

    const handleDynamicLists = () => {
        manageDynamicLists();
        closePicker();
    };

    const handleSavedLists = () => {
        manageSavedLists();
        closePicker();
    };

    return (
        <>
            <ViewItemWizard divider title={strings.View_Label_ManageDynamicLists} onClick={handleDynamicLists} />
            <ViewItemWizard title={strings.View_Label_ManageSavedLists} onClick={handleSavedLists} />
        </>
    );
};
